/*
 * wpe-freemium-form.js  ·  v2 — HONEST RESPONSES  (replaces v1 · MMP-1)
 * ============================================================================
 * Wires the EXISTING "Start the free week" form on the year-band pages
 * (the .ws-reg-card <form> in page.years-5-6 / 7-8 / 9-10 / 11-12.liquid).
 * One asset covers all four pages. No template changes needed.
 *
 * WHY v2 EXISTS (3 Aug 2026)
 * --------------------------
 * v1 posted with mode:'no-cors' — an opaque response — and showed the success
 * card no matter what the server answered. When the web app REJECTED a signup
 * (e.g. "You already have a paid Daily Success membership"), the parent still
 * saw "You're set — check your inbox", then received nothing. Observed live
 * 3 Aug 2026 (Failures tab, 09:34:59). Silent rejection is the worst outcome
 * a signup form can produce, so:
 *
 *   1. HONEST RESPONSES. The POST now reads the server's JSON (Apps Script
 *      serves it CORS-readable for simple form-urlencoded requests). Confirmed
 *      success → success card. Rejection → the server's real message, with a
 *      "Go to My Account" button when the reason is an existing paid
 *      membership. Only a genuine network failure shows the try-again error —
 *      and retrying is safe, because the server's own duplicate guards make a
 *      resubmit a no-op.
 *   2. ADS INTEGRITY. The Google Ads conversion now fires ONLY on a confirmed
 *      ok:true. v1 fired it on any POST — including rejected signups.
 *   3. AUTOFILL TRAP DEFUSED. v1 treated a filled "company" honeypot as a bot
 *      and showed fake success WITHOUT POSTING. But Chrome's address autofill
 *      routinely fills off-screen organisation fields when a parent autofills
 *      their email — silently discarding real families. v2 CLEARS the honeypot
 *      before posting (this handler running at all means a real browser on our
 *      page). The server-side honeypot check still catches direct-POST bots,
 *      which never run this script.
 *
 * PAIRS WITH: Webapp.gs v3 — handleFreemiumRegister_ returns
 *   { ok:false, code:'already_paid'|'already_registered'|'missing_fields'|
 *     'bad_secret'|'server_error', message:'…' }
 * Older deployments that return only { ok:false, error } still work — the
 * client falls back to per-code copy, then to a generic message.
 * ============================================================================
 */
(function () {
  "use strict";

  // ===== SET THIS to your web app's /exec deployment URL =====
  var WEBAPP_EXEC_URL = "https://script.google.com/macros/s/AKfycbwAmRhFnUfcOdowDURmEJ6zBEF9ja7EFDbsWuqSZ35vLkkOzHmhPE0PImkPYvhQOohZ/exec";
  var FORM_SECRET = ""; // optional; must match a FORM_SECRET Script Property if you set one
  var MY_ACCOUNT_URL = "/pages/my-account";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function esc(t) {
    return String(t == null ? "" : t)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  // Escape first, then turn bare URLs into links — so server messages that
  // include e.g. the My Account URL render as something the parent can click.
  function escWithLinks(t) {
    return esc(t).replace(/(https?:\/\/[^\s<]+)/g, function (u) {
      return '<a href="' + u + '" style="color:#3E6B54;">' + u + "</a>";
    });
  }

  ready(function () {
    var card = document.querySelector(".ws-reg-card");
    if (!card) return;
    var form = card.querySelector("form");
    // only wire the freemium form (feature-detect its fields)
    if (!form || !form.querySelector('[name="child-email"]') || !form.querySelector('[name="year"]')) return;

    form.setAttribute("action", "#"); // we submit via fetch; neutralise native nav

    // live child-name into the consent line (if the consent span is present)
    var childInput = form.querySelector('[name="child"]');
    function refreshName() {
      var n = (childInput && childInput.value.trim()) || "my child";
      card.querySelectorAll(".wpe-ff-childname").forEach(function (s) { s.textContent = n; });
    }
    if (childInput) childInput.addEventListener("input", refreshName);

    // error line (created once, placed above the submit button)
    var submitBtn = form.querySelector('button[type="submit"], .ws-form-submit');
    var errorEl = document.createElement("p");
    errorEl.setAttribute("role", "alert");
    errorEl.style.cssText = "color:#B85842;font-size:13.5px;margin:0 0 12px;display:none";
    if (submitBtn) form.insertBefore(errorEl, submitBtn);

    function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function val(name) { var el = form.elements[name]; return el ? String(el.value || "").trim() : ""; }
    function showError(msg) { errorEl.textContent = msg; errorEl.style.display = "block"; }
    function resetButton() {
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = "Start the free week"; }
    }

    function validate() {
      var year = form.querySelector('[name="year"]:checked');
      var consent = form.elements["consent"];
      if (!val("child")) return "Please add your child’s first name.";
      if (!isEmail(val("email"))) return "Please enter a valid parent email.";
      if (!isEmail(val("child-email"))) return "Please enter a valid email for your child.";
      if (!year) return "Please choose your child’s year.";
      if (consent && !consent.checked) return "Please tick the consent box so we can set up the account.";
      return null;
    }

    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      errorEl.style.display = "none";

      // Honeypot — CLEAR it, never silently drop. This handler running at all
      // means a real browser interacted with our page; the only realistic way
      // the field gets filled here is Chrome autofilling "Company" alongside
      // the parent's email. v1's silent drop threw those real families away.
      // Direct-POST bots never run this script, and the SERVER-side honeypot
      // check still catches them.
      var hp = form.elements["company"];
      if (hp && hp.value) hp.value = "";

      var msg = validate();
      if (msg) { showError(msg); return; }

      var qs = new URLSearchParams(location.search);
      var body = new URLSearchParams();
      body.set("action", "freemium_register");
      if (FORM_SECRET) body.set("secret", FORM_SECRET);
      body.set("email", val("email"));
      body.set("child", val("child"));
      body.set("child_email", val("child-email"));
      body.set("year", (form.querySelector('[name="year"]:checked') || {}).value || "");
      body.set("consent", "true");
      var consentSpan = card.querySelector(".wpe-ff-consent-text");
      body.set("consent_text", consentSpan ? consentSpan.textContent.trim() : "");
      body.set("utm_source", qs.get("utm_source") || "");
      body.set("utm_medium", qs.get("utm_medium") || "");
      body.set("utm_campaign", qs.get("utm_campaign") || "");
      body.set("signup_landing_path", location.pathname || "");
      body.set("referrer", document.referrer || "");
      body.set("form_version", "yearband-v2");

      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Setting up…"; }

      // CORS-readable POST. form-urlencoded is a "simple request" (no
      // preflight), and Apps Script's redirected ContentService response
      // carries Access-Control-Allow-Origin:*, so the JSON is readable and we
      // can tell the parent the truth. A rejected fetch here means the network
      // itself failed — we show try-again, which is safe to act on because the
      // server's duplicate guards make a resubmit harmless.
      fetch(WEBAPP_EXEC_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: body.toString()
      })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (data) {
        if (data && data.ok === true) {
          fireAdsConversion();                       // confirmed signups only
          showSuccess(val("email"));
        } else if (data && data.ok === false) {
          showRejection(data);
        } else {
          // Delivered, but the body was unreadable (unexpected). The request
          // reached the server, so optimistic success — v1's behaviour — is
          // the right fallback here, not an error that prompts a resubmit.
          showSuccess(val("email"));
        }
      })
      .catch(function () {
        resetButton();
        showError("Something went wrong sending that — please try again, or email hello@writepatheducation.com and we’ll set it up for you.");
      });
    });

    // Google Ads conversion — "Free trial sign-up (first week free)" (AW-11316543016).
    // v2: fires ONLY on a server-confirmed registration, so rejected signups
    // (already-paid, already-trialed, bots) no longer count as conversions.
    function fireAdsConversion() {
      try {
        if (typeof gtag === "function") {
          gtag("event", "conversion", {
            "send_to": "AW-11316543016/-OtHCNervtIcEKj8kpQq",
            "value": 1.0,
            "currency": "AUD"
          });
        }
      } catch (e) {}
    }

    function hideForm() {
      var note = card.querySelector(".ws-form-note");
      form.style.display = "none";
      if (note) note.style.display = "none";
    }

    function showSuccess(email) {
      hideForm();
      var ok = document.createElement("div");
      ok.className = "wpe-ff-success";
      ok.innerHTML =
        "<h3>You’re set — check your inbox.</h3>" +
        "<p>Your child’s Free First Week is ready, starting with one short module (about 15 minutes). " +
        "We’ve emailed a sign-in link to <b>" + esc(email || "your email") + "</b> — and the feedback lands in your inbox too.</p>";
      card.appendChild(ok);
      ok.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // The server said no — tell the parent why, in the server's own words
    // (Registration.gs writes these messages for parents), with a sensible
    // action. The form stays recoverable for correctable cases.
    function showRejection(data) {
      var code = String(data.code || "");
      var serverMsg = String(data.message || data.error || "").trim();

      var fallbackByCode = {
        already_paid: "This email already has an active Daily Success membership — the Free First Week is for new families. You can add or manage your child from My Account.",
        already_registered: "This family has already used the Free First Week, or this email is already registered with WritePath. If that doesn’t sound right, email hello@writepatheducation.com and we’ll sort it out.",
        missing_fields: "Some details were missing or didn’t look right — please check the form and try again.",
        bad_secret: "This page looks out of date — please refresh and try again."
      };
      var text = serverMsg || fallbackByCode[code] ||
        "We couldn’t set that up automatically — please email hello@writepatheducation.com and we’ll do it for you.";

      // Correctable inputs → keep the form on screen with an inline error.
      if (code === "missing_fields" || code === "bad_secret") {
        resetButton();
        showError(text);
        return;
      }

      // Account-level outcomes → replace the form with an honest card.
      hideForm();
      var box = document.createElement("div");
      box.className = "wpe-ff-rejected";
      var actions = "";
      if (code === "already_paid") {
        actions = '<p style="margin-top:16px;"><a class="ws-btn ws-btn--buy" href="' + MY_ACCOUNT_URL + '">Go to My Account</a></p>';
      }
      box.innerHTML =
        "<h3>One thing to sort out first</h3>" +
        "<p>" + escWithLinks(text) + "</p>" +
        actions +
        '<p style="font-size:13px;color:#5C5876;margin-top:14px;">Need a hand? Email <a href="mailto:hello@writepatheducation.com" style="color:#3E6B54;">hello@writepatheducation.com</a>.</p>';
      card.appendChild(box);
      box.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
})();